import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class VehicleTypeService {

    static getvehicleType(item) {

        let api = `${API_BASE_URL}${API_PATHS.getvehicleType}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
       
        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api,item);
    }

    static addvehicleType(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addvehicleType}`;
        return axiosInstance
            .post(api, data)

    }

    static editvehicleType(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editvehicleType}`;
        return axiosInstance
            .put(api, data)

    }

    static deletevehicleType(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deletevehicleType}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default VehicleTypeService;
